import React from 'react';

interface IconProps {
  width?: string;
  height?: string;
}

export const EngineerIcon: React.FC<IconProps> = ({ width = 25, height = 24 }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_7211_22202)'>
        <path
          d='M4.33301 14V11C4.33301 8.87827 5.17586 6.84344 6.67615 5.34315C8.17644 3.84285 10.2113 3 12.333 3C14.4547 3 16.4896 3.84285 17.9899 5.34315C19.4902 6.84344 20.333 8.87827 20.333 11V14'
          stroke='#04A0C5'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M18.333 19C18.333 20.657 15.647 22 12.333 22'
          stroke='#04A0C5'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.33301 14C4.33301 13.4696 4.54372 12.9609 4.91879 12.5858C5.29387 12.2107 5.80257 12 6.33301 12H7.33301C7.86344 12 8.37215 12.2107 8.74722 12.5858C9.12229 12.9609 9.33301 13.4696 9.33301 14V17C9.33301 17.5304 9.12229 18.0391 8.74722 18.4142C8.37215 18.7893 7.86344 19 7.33301 19H6.33301C5.80257 19 5.29387 18.7893 4.91879 18.4142C4.54372 18.0391 4.33301 17.5304 4.33301 17V14Z'
          stroke='#04A0C5'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.333 14C15.333 13.4696 15.5437 12.9609 15.9188 12.5858C16.2939 12.2107 16.8026 12 17.333 12H18.333C18.8634 12 19.3721 12.2107 19.7472 12.5858C20.1223 12.9609 20.333 13.4696 20.333 14V17C20.333 17.5304 20.1223 18.0391 19.7472 18.4142C19.3721 18.7893 18.8634 19 18.333 19H17.333C16.8026 19 16.2939 18.7893 15.9188 18.4142C15.5437 18.0391 15.333 17.5304 15.333 17V14Z'
          stroke='#04A0C5'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_7211_22202'>
          <rect width='24' height='24' fill='white' transform='translate(0.333008)' />
        </clipPath>
      </defs>
    </svg>
  );
};
